import React from 'react';
import { useTranslation } from 'react-i18next';

import warningIcon from '../../assets/insurance/warning.svg';

import styles from './ClaimNotification.module.css';

export const ClaimNotification = ({ onContactUsClick = () => { } }) => {
  const { t } = useTranslation('insurance');

  return (
    <div className={styles.mainContainer}>
      <div className={`${styles.row} ${styles.gap8}`}>
        <img alt="" src={warningIcon} />

        <h2 className={styles.title}>{t('claimNotification.title')}</h2>
      </div>

      <div className={`${styles.row} ${styles.spaceBetween} ${styles.gap16}`}>
        <p className={styles.description}>
          {t('claimNotification.description')}
        </p>

        <button
          className={styles.contactSupportButton}
          onClick={onContactUsClick}
          type="button"
        >
          {t('claimNotification.contactSupport')}
        </button>
      </div>
    </div>
  );
};
